import Bragina from "../assets/Bragina.png";
import Nekrasova from "../assets/Nekrasova.jpg";
import Paramonov from "../assets/Paramonov.jpg";
import Kolodiychik from "../assets/Kolodiychik.png";
import Dagar from "../assets/Dagar.jpg";
import Romanova from "../assets/Romanova.jpg";
import Akulova from "../assets/Akulova.png";
import Razumovskaya from "../assets/Razumovskaya.jpg";
import Malysheva from "../assets/Malysheva.jpg";

export const schedule = [
  {
    id: 1,
    startTime: "09:30",
    endTime: "10:00",
    title: "Регистрация участников",
  },
  {
    id: 2,
    startTime: "10:00",
    endTime: "10:10",
    title: "Открытие конгресса",
  },
  {
    id: 3,
    startTime: "10:10",
    endTime: "11:00",
    title: "Рубцы! Что нового и интересного?",
    image: Bragina,
    experts: ["Брагина Ирина Юрьевна"],
  },
  {
    id: 4,
    startTime: "11:00",
    endTime: "11:40",
    title:
      "Основные  принципы  и правила подбора аппаратных и инъекционных  методик в лечение  рубцов.",
    image: Nekrasova,
    experts: ["Некрасова Светлана Владимировна"],
  },
  {
    id: 5,
    startTime: "11:40",
    endTime: "12:10",
    title: "Перспективные технологии лечения рубцов.",
    image: Paramonov,
    experts: ["Парамонов Борис Алексеевич"],
  },
  {
    id: 6,
    startTime: "12:10",
    endTime: "12:40",
    title:
      "Послеоперационная реабилитация пациента с помощью Cortexil PRP в целях профилактики формирования грубых гипер тропических и атрофических рубцов.",
    image: Kolodiychik,
    experts: ["Колодийчик Светлана Михайловна"],
  },
  {
    id: 7,
    startTime: "12:40",
    endTime: "13:10",
    title:
      "Стерильные биорепаративные сыворотки REVICELL в лечении рубцов: потенцирование эффекта через аппаратные   микроканальные технологии.",
    image: Dagar,
    experts: ["Дагар Алёна Александровна"],
  },
  {
    id: 8,
    startTime: "13:10",
    endTime: "14:10",
    title: "Кофе брейк",
  },
  {
    id: 9,
    startTime: "14:10",
    endTime: "14:40",
    title:
      "Протоколы применения экзосомальных продуктов в моно протоколах, в комбинации с лекарственными препаратами,  аппаратными методами лечения",
    image: Malysheva,
    experts: ["Малышева Анна Ивановна"],
  },
  {
    id: 10,
    startTime: "14:40",
    endTime: "15:10",
    title:
      "Коллаген не главный. Что на самом деле формирует рубец. Как повлиять на клеточное окружение после кесарева сечения.",
    image: Romanova,
    experts: ["Романова Светлана Борисовна"],
  },
  {
    id: 11,
    startTime: "15:10",
    endTime: "15:40",
    title:
      "Эрбиевый лазер 1540 нм и 2940 нм в коррекции рубцов. Патогенетическое обоснование",
    image: Akulova,
    experts: ["Акулова Наталия Александровна"],
  },
  {
    id: 12,
    title: "Розыгрыш ценных призов",
  },
  {
    id: 13,
    startTime: "15:40",
    endTime: "16:10",
    title:
      "Дерматоатрофии: комплексная коррекция. Стрии, патагенез, лечение. Особые техники коррекции стрий. Применение полимолочной кислоты, экзосомальной терапии после игольчатого RF и комбинация метов в гибридных протоколах. Особые техники коррекции стрий.",
    image: Razumovskaya,
    experts: ["Разумовская Елена Александровна"],
  },
  {
    id: 14,
    startTime: "16:10",
    endTime: "16:40",
    title: "Терапия рубцов у сложных пациентов.",
    image: Nekrasova,
    experts: ["Некрасова Светлана Владимировна"],
  },
  {
    id: 15,
    startTime: "16:40",
    endTime: "17:10",
    title: "Мезанизмы действия БТА в коррекции рубцов",
    image: Razumovskaya,
    experts: ["Разумовская Елена Александровна"],
  },
  {
    id: 16,
    startTime: "17:10",
    endTime: "17:40",
    title: "Терапия рубцовых поражений: апдейт.",
    image: Bragina,
    experts: ["Брагина Ирина Юрьевна"],
  },
  {
    id: 17,
    startTime: "17:40",
    endTime: "18:30",
    title: "Ответ-вопрос спикерам конгресса",
  },
];
